import Axios from 'axios'
import * as C from "../constants/api"
import  utils from './utils'
import {
    MessageBox
} from 'mint-ui';
const METHODS = {
    GET: 'get',
    POST: 'post',
    PUT: 'put',
    DELETE: 'delete' 
};
Axios.defaults.headers.get['content-type'] = 'application/json;charset=UTF-8'
//请求拦截器
Axios.interceptors.request.use((config) => {
    // console.log(config);

    if (config.method === 'get') {
        config.data = {
            unused: 0
        } // 这个是关键点，加入这行就可以了
    }
    return config;
})
//响应拦截器
Axios.interceptors.response.use(response => { 
	console.log(response)
    let {
        data: resp
    } = response; 
    return new Promise((resolve, reject) => {
        const {
            errorCode
        } = resp; 
        if (errorCode) { 
            reject(resp);
        } else {
			  
            sessionStorage.setItem('#OpTime', JSON.stringify(resp.OpTime))
		   if(response.data instanceof Blob){ 
			      resolve(response.data)
		   }
           else if (resp.Code == 1||resp.Code==0) {
                resolve(resp.Data)
            } else {
                MessageBox({
                    message: resp.Message,
                    title: '提示'
                });
                reject(resp);
            }
        }
    });
}, error => {
    const {
        response
    } = error
    let errorMsg = ''

    if (!response) {
        errorMsg = '网络错误，请检测网络是否正常!'
    } else {
        const {
            data
        } = response
        // console.log(response);
        errorMsg = data && data.errorMsg ? data.errorMsg : '服务器发生异常，请联系管理员'
    }
    // MessageBox({ message: errorMsg, title: '提示' });
    return Promise.reject(error);
});

const request = (url, params = {}, headers = {}, method = METHODS.GET,blob=false) => {
	 
   const toKen=sessionStorage.getItem("#Token")||"";  
    let options = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
			
			Authorization:`Bearer ${toKen}`,
            ...headers,
        },
        method: method,
		
    };  
	if(blob){
		options.responseType= 'blob';
	}
    if (method === METHODS.POST || method == METHODS.PUT) {
        if (options.headers['Content-Type'] === 'application/json;charset=UTF-8') {
            options.data = params
        } else {
            options.data = queryString.stringify(params);
        }
    } else if (method === METHODS.GET || method == METHODS.DELETE) {
        // console.log(options);
        // options.params = queryString.stringify(params);
        options.params = params;
    }  
    return Axios({
        url,
        ...options
    });
};
const post = (url, params, headers) => request(url, params, headers, METHODS.POST);
const posts=(url,params,headers)=> request(url, params, headers, METHODS.POST,true);
const http = {
	//网站基本信息
	BasInfo:(params) => post(C.BASE_INFO, params),
	NavInfo:(params) => post(C.NAV_INFO, params),
	querySearch:(params,Token)=>post(C.QUERY_SEARCH,params),
	querySearchPage:(params,Token)=>post(C.QUERY_SEARCHPAGE,params),
	queryInfo:(params)=>post(C.QUERY_INFO,params), 
	queryCdgb:(params)=>post(C.QUERY_CDGB,params),
	QueryAutherCdgb:(params)=>post(C.QUERY_AUTHERCDGB,params),
	queryAuthorSearch:(params)=>post(C.QUERY_AUTHER,params),
	QueryAuthorPage:(params)=>post(C.QUERY_AUTHERPAGE,params),
	QueryInfoAuthor:(params)=>post(C.QUERY_INFOAUTHOR,params),
	QueryBookIndexSearch:(params)=>post(C.QUERY_BOOINDEX,params),
	QueryBodyIndexPage:(params)=>post(C.QUERY_BOOKINDEXPAGE,params),
	QueryPindexSearch:(params)=>post(C.QUERY_PINDEX,params),
	QueryPindexSearchPage:(params)=>post(C.QUERY_PINDEXPAGE,params),
	QueryFolderPicture:(params)=>post(C.QUERY_FOLDERPICTURE,params),
	QueryFolderPictureMax:(params)=>post(C.QUERY_FOLDERPICTUREMAX,params),
	 SendEmail:(params)=>post(C.SEND_EMAIL,params),
	 DOWImage:(params)=>posts(C.DOW_Image,params),
	Login:(params)=>post(C.LOGIN,params),
	GetIP:(params)=>request(C.QUERYIP,params),
	};
	var httpObj = {
	    install(Vue) {
	        Vue.prototype.$http = http;
	    }
	};
	
	export {
	    httpObj as
	    default,
	    http
	};
